import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum Channel {
  sms = 'sms',
  whatsapp = 'whatsapp',
  viber = 'viber',
}

interface CdrsState {
  channel: Channel;
}

const initialState: CdrsState = { channel: Channel.sms };

const CDRsSlice = createSlice({
  name: 'CDRs',
  initialState,
  reducers: {
    setChannel: (state, action: PayloadAction<Channel>) => {
      state.channel = action.payload;
    },
  },
});

export const { setChannel } = CDRsSlice.actions;

export default CDRsSlice.reducer;
